/**
 * Preferred Location Product - Gestion de la disponibilité par magasin préféré
 * 
 * Dépendances:
 * - assets/locations.js (fetchLocations, fetchLocation, locationDetails, preferredLocationId, etc.)
 * - assets/geolocation.js (storeAndGetGeolocPosition)
 * - API: /apps/popshoesinventories/variants/{id}/inventory_levels.json
 * 
 * Events:
 * - set_preferred_location_id_event: Déclenché quand le magasin préféré change
 * - set_address_form_coordinates: Déclenché quand l'adresse change
 */

// I18n Messages
const availableInStoreMsg = document.querySelector('#availableInStoreMsg')?.innerText || 'Available in store';
const notAvailableInStoreMsg = document.querySelector('#notAvailableInStoreMsg')?.innerText || 'Not available in store';
const availableOnlineMsg = document.querySelector('#availableOnlineMsg')?.innerText || 'Available online';
const notAvailableOnlineMsg = document.querySelector('#notAvailableOnlineMsg')?.innerText || 'Not available online';
const inStockAtMsg = document.querySelector('#inStockAtMsg')?.innerText || 'in stock at';
const searchableOnlyMsg = document.querySelector('#searchableOnlyMsg')?.innerText || 'This item can be ordered through this location';
const selectOtherStore = document.querySelector('#selectOtherStore')?.innerText || 'Choose another store';
const selectStore = document.querySelector('#selectStore')?.innerText || 'Select a store';
const pickup_unavailable = document.querySelector('#pickup_unavailable')?.innerText || 'Pickup unavailable';

// SVG Icons
const storeIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><g><rect fill="none" height="24" width="24"/></g><g><g/><g><path d="M21.9,8.89l-1.05-4.37c-0.22-0.9-1-1.52-1.91-1.52H5.05C4.15,3,3.36,3.63,3.15,4.52L2.1,8.89 c-0.24,1.02-0.02,2.06,0.62,2.88C2.8,11.88,2.91,11.96,3,12.06V19c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6.94 c0.09-0.09,0.2-0.18,0.28-0.28C21.92,10.96,22.15,9.91,21.9,8.89z M18.91,4.99l1.05,4.37c0.1,0.42,0.01,0.84-0.25,1.17 C19.57,10.71,19.27,11,18.77,11c-0.61,0-1.14-0.49-1.21-1.14L16.98,5L18.91,4.99z M13,5h1.96l0.54,4.52 c0.05,0.39-0.07,0.78-0.33,1.07C14.95,10.85,14.63,11,14.22,11C13.55,11,13,10.41,13,9.69V5z M8.49,9.52L9.04,5H11v4.69 C11,10.41,10.45,11,9.71,11c-0.34,0-0.65-0.15-0.89-0.41C8.57,10.3,8.45,9.91,8.49,9.52z M4.04,9.36L5.05,5h1.97L6.44,9.86 C6.36,10.51,5.84,11,5.23,11c-0.49,0-0.8-0.29-0.93-0.47C4.03,10.21,3.94,9.78,4.04,9.36z M5,19v-6.03C5.08,12.98,5.15,13,5.23,13 c0.87,0,1.66-0.36,2.24-0.95c0.6,0.6,1.4,0.95,2.31,0.95c0.87,0,1.65-0.36,2.23-0.93c0.59,0.57,1.39,0.93,2.29,0.93 c0.84,0,1.64-0.35,2.24-0.95c0.58,0.59,1.37,0.95,2.24,0.95c0.08,0,0.15-0.02,0.23-0.03V19H5z"/></g></g></svg>`;

const deliveryIconSvg = `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g><path d="M386.689,304.403c-35.587,0-64.538,28.951-64.538,64.538s28.951,64.538,64.538,64.538c35.593,0,64.538-28.951,64.538-64.538S422.276,304.403,386.689,304.403z M386.689,401.21c-17.796,0-32.269-14.473-32.269-32.269c0-17.796,14.473-32.269,32.269-32.269c17.796,0,32.269,14.473,32.269,32.269C418.958,386.738,404.485,401.21,386.689,401.21z"/></g></g><g><g><path d="M166.185,304.403c-35.587,0-64.538,28.951-64.538,64.538s28.951,64.538,64.538,64.538s64.538-28.951,64.538-64.538S201.772,304.403,166.185,304.403z M166.185,401.21c-17.796,0-32.269-14.473-32.269-32.269c0-17.796,14.473-32.269,32.269-32.269c17.791,0,32.269,14.473,32.269,32.269C198.454,386.738,183.981,401.21,166.185,401.21z"/></g></g><g><g><path d="M430.15,119.675c-2.743-5.448-8.32-8.885-14.419-8.885h-84.975v32.269h75.025l43.934,87.384l28.838-14.5L430.15,119.675z"/></g></g><g><g><rect x="216.202" y="353.345" width="122.084" height="32.269"/></g></g><g><g><path d="M117.781,353.345H61.849c-8.912,0-16.134,7.223-16.134,16.134c0,8.912,7.223,16.134,16.134,16.134h55.933c8.912,0,16.134-7.223,16.134-16.134C133.916,360.567,126.693,353.345,117.781,353.345z"/></g></g><g><g><path d="M508.612,254.709l-31.736-40.874c-3.049-3.937-7.755-6.239-12.741-6.239H346.891V94.655c0-8.912-7.223-16.134-16.134-16.134H61.849c-8.912,0-16.134,7.223-16.134,16.134s7.223,16.134,16.134,16.134h252.773v112.941c0,8.912,7.223,16.134,16.134,16.134h125.478l23.497,30.268v83.211h-44.639c-8.912,0-16.134,7.223-16.134,16.134c0,8.912,7.223,16.134,16.134,16.134h60.773c8.912,0,16.134-7.223,16.135-16.134V264.605C512,261.023,510.806,257.538,508.612,254.709z"/></g></g><g><g><path d="M116.706,271.597H42.487c-8.912,0-16.134,7.223-16.134,16.134c0,8.912,7.223,16.134,16.134,16.134h74.218c8.912,0,16.134-7.223,16.134-16.134C132.84,278.82,125.617,271.597,116.706,271.597z"/></g></g><g><g><path d="M153.815,208.134H16.134C7.223,208.134,0,215.357,0,224.269s7.223,16.134,16.134,16.134h137.681c8.912,0,16.134-7.223,16.134-16.134S162.727,208.134,153.815,208.134z"/></g></g><g><g><path d="M180.168,144.672H42.487c-8.912,0-16.134,7.223-16.134,16.134c0,8.912,7.223,16.134,16.134,16.134h137.681c8.912,0,16.134-7.223,16.134-16.134C196.303,151.895,189.08,144.672,180.168,144.672z"/></g></g></svg>`;

const unavailableIconClass = 'not-available';

document.addEventListener("DOMContentLoaded", function() {
  const variantInputs = document.querySelectorAll('.variant-input label, .opt-btn');
  const dispoElement = document.getElementById('preferred-location-availability');
  
  if (!dispoElement) {
    return;
  }

  const persistLastPreferredLocationId = () => {
    dispoElement.dataset.lastPreferredLocationId = preferredLocationId();
  };
  
  persistLastPreferredLocationId();
  
  /**
   * Récupère et affiche les disponibilités pour le variant actuel
   */
  const getAvailabilities = () => {
    setTimeout(() => {
      const queryString = window.location.search;
      const queryChanged = dispoElement.dataset.lastQuery != queryString;
      const preferredLocationIdChanged = dispoElement.dataset.lastPreferredLocationId != preferredLocationId();
      
      if (!queryChanged && !preferredLocationIdChanged) return;

      dispoElement.dataset.lastQuery = queryString;
      persistLastPreferredLocationId();
      
      const urlParams = new URLSearchParams(queryString);
      var urlParamsVariant = urlParams.get('variant');
      
      if (urlParamsVariant == null) {
        urlParamsVariant = dispoElement.dataset.currentVariantId;
      }
      
      if (urlParamsVariant != null) {
        checkAndInsertVariantAvailabilityForShop(urlParamsVariant);
      }
    }, 50);
  };

  /**
   * Toggle le modal de sélection de magasin
   */
  const toggleSelectStoreSideBar = () => {
    const locationSelectOtherStoreSidebar = document.querySelector('#locationSelectOtherStoreSidebar');
    const bgCover = document.querySelector('.prefloc-sidebar__bgcover');
    
    locationSelectOtherStoreSidebar.classList.toggle('open');
    
    if (locationSelectOtherStoreSidebar.classList.contains('open')) {
      bgCover.style.display = 'block';
      document.body.classList.add('prefloc-sidebar-open');
    } else {
      bgCover.style.display = 'none';
      document.body.classList.remove('prefloc-sidebar-open');
    }
  };

  /**
   * Récupère l'ID de l'emplacement par défaut
   */
  async function getDefaultLocationId() {
    const defloc_id = await defaultLocationId();
    return defloc_id;
  }

  /**
   * Vérifie et affiche la disponibilité d'un variant pour le magasin sélectionné
   */
  const checkAndInsertVariantAvailabilityForShop = async (variantId) => {
    console.log('Fetching inventory for variant ID:', variantId);
    if (preferredLocationId() && dispoElement) {
      const locDetails = await locationDetails(preferredLocationId());
      dispoElement.insertAdjacentHTML('afterbegin', `<div class="loading"></div>`);
      
      fetchData(`/apps/popshoesinventories/variants/${variantId}/inventory_levels.json`)
        .then(data => {
          console.log('API response received, data:', data ? 'OK' : 'empty');
          
          if (!data) {
            console.error('API fetch error for variant', variantId, ': No data returned');
            dispoElement.style.opacity = "0";
            dispoElement.innerHTML = '';
            return;
          }
        let available_in_preferred_location = false;
        let available_in_default_location = false;
        let exist_in_preferred_location = false;
        
        dispoElement.innerHTML = '';
        dispoElement.style.opacity = 0;

        if (data) {
          data.inventory_levels.forEach((inventory) => {
            if (inventory.location_id === parseInt(defaultLocationId(), 10) && inventory.available > 0) {
              available_in_default_location = true;
            }

            if (inventory.location_id === parseInt(preferredLocationId(), 10) && inventory.available > 0) {
              dispoElement.insertAdjacentHTML('afterbegin',
                `<div>
                  <span class="icon">${storeIconSvg}</span>
                  <div>
                    <span class="label"><strong>${availableInStoreMsg}</strong></span>
                    <span class="location-text">
                      <span class="location-green-dot"></span>
                      <strong>${inventory.available}</strong> ${inStockAtMsg.toLowerCase()}
                    </span>
                    <span class="location-text">${locDetails.name} ${locDetails.city}, ${locDetails.zip}</span>
                    <span class="btn-show-location-select-other-store">${selectOtherStore}</span>
                  </div>
                </div>`
              );
              available_in_preferred_location = true;
            }

            if (inventory.location_id === parseInt(preferredLocationId(), 10)) {
              exist_in_preferred_location = true;
            }
          });
        }
        
        // Disponible en ligne
        if (available_in_default_location) {
          dispoElement.insertAdjacentHTML('beforeend',
            `<div>
              <span class="icon">${deliveryIconSvg}</span>
              <div><span class="label"><strong>${availableOnlineMsg}</strong></span></div>
            </div>`
          );
        } else if (!data && !available_in_default_location) {
          dispoElement.insertAdjacentHTML('beforeend',
            `<div>
              <span class="icon ${unavailableIconClass}">${deliveryIconSvg}</span>
              <div><span class="label ${unavailableIconClass}"><strong>${pickup_unavailable}</strong></span></div>
            </div>`
          );
        } else {
          dispoElement.insertAdjacentHTML('beforeend',
            `<div>
              <span class="icon ${unavailableIconClass}">${deliveryIconSvg}</span>
              <div><span class="label ${unavailableIconClass}"><strong>${notAvailableOnlineMsg}</strong></span></div>
            </div>`
          );
        }

        // Searchable only location
        const isSearchableOnly = preferredLocationSearchableOnly() === true || preferredLocationSearchableOnly() === 'true';
        
        if (isSearchableOnly) {
          dispoElement.insertAdjacentHTML('afterbegin',
            `<div>
              <span class="icon">${storeIconSvg}</span>
              <div>
                <span class="label"><strong>${searchableOnlyMsg}</strong></span>
                <span class="location-text">${locDetails.name} ${locDetails.city}, ${locDetails.zip}</span>
                <span class="btn-show-location-select-other-store">${selectOtherStore}</span>
              </div>
            </div>`
          );
        } else if (!available_in_preferred_location) {
          // Non disponible en magasin préféré
          dispoElement.insertAdjacentHTML('afterbegin',
            `<div>
              <span class="icon ${unavailableIconClass}">${storeIconSvg}</span>
              <div>
                <span class="label ${unavailableIconClass}"><strong>${notAvailableInStoreMsg}</strong></span>
                <span class="location-text">${locDetails.name} ${locDetails.city}, ${locDetails.zip}</span>
                <span class="btn-show-location-select-other-store">${selectOtherStore}</span>
              </div>
            </div>`
          );
        }
        
        dispoElement.style.opacity = 1;
        console.log('Block updated, opacity set to 1, innerHTML length:', dispoElement.innerHTML.length);
        
        // Attacher l'event listener au bouton de sélection
        const selectBtn = dispoElement.querySelector('.btn-show-location-select-other-store');
        if (selectBtn) {
          selectBtn.addEventListener('click', toggleSelectStoreSideBar);
        }
        })
        .catch(error => {
          console.error('API fetch error for variant', variantId, ':', error);
          dispoElement.style.opacity = "0";
          dispoElement.innerHTML = '';
        });
    } else if (dispoElement) {
      // Aucun magasin préféré sélectionné
      getDefaultLocationId().then(() => {
        dispoElement.insertAdjacentHTML('afterbegin', `<div class="loading"></div>`);

        fetchData(`/apps/popshoesinventories/variants/${variantId}/inventory_levels.json`)
          .then(data => {
            console.log('API response received, data:', data ? 'OK' : 'empty');
            
            if (!data) {
              console.error('API fetch error for variant', variantId, ': No data returned');
              dispoElement.style.opacity = "0";
              dispoElement.innerHTML = '';
              return;
            }
          let available_in_default_location = false;
          let available_in_at_least_one_location = false;
          let default_location_id = parseInt(defaultLocationId(), 10);
          
          dispoElement.innerHTML = '';
          dispoElement.style.opacity = 0;

          if (data) {
            data.inventory_levels.forEach((inventory) => {
              if (inventory.location_id === default_location_id && inventory.available > 0) {
                available_in_default_location = true;
              }

              if (inventory.location_id != default_location_id && !available_in_at_least_one_location && inventory.available > 0) {
                available_in_at_least_one_location = true;
              }
            });

            if (available_in_at_least_one_location && available_in_default_location) {
              dispoElement.insertAdjacentHTML('afterbegin',
                `<div>
                  <span class="icon">${storeIconSvg}</span>
                  <div>
                    <span class="label"><strong>${availableInStoreMsg}</strong></span>
                    <span class="btn-show-location-select-other-store">${selectStore}</span>
                  </div>
                </div>`
              );

              dispoElement.insertAdjacentHTML('beforeend',
                `<div>
                  <span class="icon">${deliveryIconSvg}</span>
                  <div><span class="label"><strong>${availableOnlineMsg}</strong></span></div>
                </div>`
              );

              dispoElement.style.opacity = 1;
              
              const selectBtn = dispoElement.querySelector('.btn-show-location-select-other-store');
              if (selectBtn) {
                selectBtn.addEventListener('click', toggleSelectStoreSideBar);
              }
            } else if (available_in_at_least_one_location) {
              dispoElement.insertAdjacentHTML('afterbegin',
                `<div>
                  <span class="icon">${storeIconSvg}</span>
                  <div>
                    <span class="label"><strong>${availableInStoreMsg}</strong></span>
                    <span class="btn-show-location-select-other-store">${selectStore}</span>
                  </div>
                </div>`
              );

              dispoElement.style.opacity = 1;
              
              const selectBtn = dispoElement.querySelector('.btn-show-location-select-other-store');
              if (selectBtn) {
                selectBtn.addEventListener('click', toggleSelectStoreSideBar);
              }
            }
          }
        })
        .catch(error => {
          console.error('API fetch error for variant', variantId, ':', error);
          dispoElement.style.opacity = "0";
          dispoElement.innerHTML = '';
        });
      });
    }
  };

  // Event listeners
  window.addEventListener('set_preferred_location_id_event', getAvailabilities);

  // Listen to theme's variant change event (dispatched by variant-picker component)
  document.addEventListener('on:variant:change', (evt) => {
    console.log('on:variant:change triggered, variant ID:', evt.detail?.variant?.id);
    if (evt.detail && evt.detail.variant && evt.detail.variant.id) {
      // Directly update availability with the new variant ID from the event
      checkAndInsertVariantAvailabilityForShop(evt.detail.variant.id);
    }
  });

  // Initial load
  if (dispoElement) {
    setTimeout(function() {
      checkAndInsertVariantAvailabilityForShop(dispoElement.dataset.currentVariantId);
    }, 1000);
  }
});
